import { httpService } from 'core-utilities';
import { getSessionUrlConfig } from '../constants/urlConstants';

const getSessionUrl = identifier => {
  const urlConfig = getSessionUrlConfig();
  const params = { identifier };
  return httpService.get(urlConfig, params).then(({ data }) => {
    return data.url;
  });
};

export default getSessionUrl;
